/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

export const viewDictionary = {};

viewDictionary['__local__|__local__|modules|advanced-notes|advanced-notes'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-advanced-notes' */
                'partner/modules/advanced-notes/advanced-notes.view.tsx'),
            cn: '__local__-__local__-advanced-notes'
            };
viewDictionary['__local__|__local__|modules|allowable-freight|allowable-freight'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-allowable-freight' */
                'partner/modules/allowable-freight/allowable-freight.view.tsx'),
            cn: '__local__-__local__-allowable-freight'
            };
viewDictionary['__local__|__local__|modules|ari-search-results|ari-search-results'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-ari-search-results' */
                'partner/modules/ari-search-results/ari-search-results.view.tsx'),
            cn: '__local__-__local__-ari-search-results'
            };
viewDictionary['__local__|__local__|modules|b2b-account-management-address|b2b-account-management-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-b2b-account-management-address' */
                'partner/modules/b2b-account-management-address/b2b-account-management-address.view.tsx'),
            cn: '__local__-__local__-b2b-account-management-address'
            };
viewDictionary['__local__|__local__|modules|b2b-checkout-billing-address|b2b-checkout-billing-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-b2b-checkout-billing-address' */
                'partner/modules/b2b-checkout-billing-address/b2b-checkout-billing-address.view.tsx'),
            cn: '__local__-__local__-b2b-checkout-billing-address'
            };
viewDictionary['__local__|__local__|modules|back-order-list|back-order-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-back-order-list' */
                'partner/modules/back-order-list/back-order-list.view.tsx'),
            cn: '__local__-__local__-back-order-list'
            };
viewDictionary['__local__|__local__|modules|cart-line-comment|cart-line-comment'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cart-line-comment' */
                'partner/modules/cart-line-comment/cart-line-comment.view.tsx'),
            cn: '__local__-__local__-cart-line-comment'
            };
viewDictionary['__local__|__local__|modules|contracts-account-page|contracts-account-page'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-contracts-account-page' */
                'partner/modules/contracts-account-page/contracts-account-page.view.tsx'),
            cn: '__local__-__local__-contracts-account-page'
            };
viewDictionary['__local__|__local__|modules|education-training|education-training'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-education-training' */
                'partner/modules/education-training/education-training.view.tsx'),
            cn: '__local__-__local__-education-training'
            };
viewDictionary['__local__|__local__|modules|eve-business-partners|eve-business-partners'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-eve-business-partners' */
                'partner/modules/eve-business-partners/eve-business-partners.view.tsx'),
            cn: '__local__-__local__-eve-business-partners'
            };
viewDictionary['__local__|__local__|modules|eve-business-sign-up|eve-business-sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-eve-business-sign-up' */
                'partner/modules/eve-business-sign-up/eve-business-sign-up.view.tsx'),
            cn: '__local__-__local__-eve-business-sign-up'
            };
viewDictionary['__local__|__local__|modules|eve-checkout-shipping-address|eve-checkout-shipping-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-eve-checkout-shipping-address' */
                'partner/modules/eve-checkout-shipping-address/eve-checkout-shipping-address.view.tsx'),
            cn: '__local__-__local__-eve-checkout-shipping-address'
            };
viewDictionary['__local__|__local__|modules|eve-map|eve-map'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-eve-map' */
                'partner/modules/eve-map/eve-map.view.tsx'),
            cn: '__local__-__local__-eve-map'
            };
viewDictionary['__local__|__local__|modules|eve-quick-order|eve-quick-order'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-eve-quick-order' */
                'partner/modules/eve-quick-order/eve-quick-order.view.tsx'),
            cn: '__local__-__local__-eve-quick-order'
            };
viewDictionary['__local__|__local__|modules|eve-search-result-container|eve-search-result-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-eve-search-result-container' */
                'partner/modules/eve-search-result-container/eve-search-result-container.view.tsx'),
            cn: '__local__-__local__-eve-search-result-container'
            };
viewDictionary['__local__|__local__|modules|gdn-checkout-billing-address|gdn-checkout-billing-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gdn-checkout-billing-address' */
                'partner/modules/gdn-checkout-billing-address/gdn-checkout-billing-address.view.tsx'),
            cn: '__local__-__local__-gdn-checkout-billing-address'
            };
viewDictionary['__local__|__local__|modules|gdn-invoice-details|gdn-invoice-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gdn-invoice-details' */
                'partner/modules/gdn-invoice-details/gdn-invoice-details.view.tsx'),
            cn: '__local__-__local__-gdn-invoice-details'
            };
viewDictionary['__local__|__local__|modules|gdn-invoices-list|gdn-invoices-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gdn-invoices-list' */
                'partner/modules/gdn-invoices-list/gdn-invoices-list.view.tsx'),
            cn: '__local__-__local__-gdn-invoices-list'
            };
viewDictionary['__local__|__local__|modules|gdn-order-template|gdn-order-template'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gdn-order-template' */
                'partner/modules/gdn-order-template/gdn-order-template.view.tsx'),
            cn: '__local__-__local__-gdn-order-template'
            };
viewDictionary['__local__|__local__|modules|gdn-part-smart|gdn-part-smart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gdn-part-smart' */
                'partner/modules/gdn-part-smart/gdn-part-smart.view.tsx'),
            cn: '__local__-__local__-gdn-part-smart'
            };
viewDictionary['__local__|__local__|modules|gdn-product-specification|gdn-product-specification'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gdn-product-specification' */
                'partner/modules/gdn-product-specification/gdn-product-specification.view.tsx'),
            cn: '__local__-__local__-gdn-product-specification'
            };
viewDictionary['__local__|__local__|modules|gtm-body|gtm-body'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gtm-body' */
                'partner/modules/gtm-body/gtm-body.view.tsx'),
            cn: '__local__-__local__-gtm-body'
            };
viewDictionary['__local__|__local__|modules|model-viewer|model-viewer'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-model-viewer' */
                'partner/modules/model-viewer/model-viewer.view.tsx'),
            cn: '__local__-__local__-model-viewer'
            };
viewDictionary['__local__|__local__|modules|order-history-search|order-history-search'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-history-search' */
                'partner/modules/order-history-search/order-history-search.view.tsx'),
            cn: '__local__-__local__-order-history-search'
            };
viewDictionary['__local__|__local__|modules|order-level-comment|order-level-comment'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-level-comment' */
                'partner/modules/order-level-comment/order-level-comment.view.tsx'),
            cn: '__local__-__local__-order-level-comment'
            };
viewDictionary['__local__|__local__|modules|order-scheduler|order-scheduler'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-scheduler' */
                'partner/modules/order-scheduler/order-scheduler.view.tsx'),
            cn: '__local__-__local__-order-scheduler'
            };
viewDictionary['__local__|__local__|modules|order-upload|order-upload'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-upload' */
                'partner/modules/order-upload/order-upload.view.tsx'),
            cn: '__local__-__local__-order-upload'
            };
viewDictionary['__local__|__local__|modules|payment-container|payment-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-payment-container' */
                'partner/modules/payment-container/payment-container.view.tsx'),
            cn: '__local__-__local__-payment-container'
            };
viewDictionary['__local__|__local__|modules|po-number|po-number'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-po-number' */
                'partner/modules/po-number/po-number.view.tsx'),
            cn: '__local__-__local__-po-number'
            };
viewDictionary['__local__|__local__|modules|promo-container|promo-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-promo-container' */
                'partner/modules/promo-container/promo-container.view.tsx'),
            cn: '__local__-__local__-promo-container'
            };
viewDictionary['__local__|__local__|modules|promo-option-container|promo-option-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-promo-option-container' */
                'partner/modules/promo-option-container/promo-option-container.view.tsx'),
            cn: '__local__-__local__-promo-option-container'
            };
viewDictionary['__local__|__local__|modules|reports-export|reports-export'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-reports-export' */
                'partner/modules/reports-export/reports-export.view.tsx'),
            cn: '__local__-__local__-reports-export'
            };
viewDictionary['__local__|__local__|modules|table-browser|table-browser'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-table-browser' */
                'partner/modules/table-browser/table-browser.view.tsx'),
            cn: '__local__-__local__-table-browser'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|account-management-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-management-address' */
                'partner/themes/gardner-theme-b2c/views/account-management-address.view.tsx'),
            cn: '__local__-__local__-account-management-address'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|account-profile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-profile' */
                'partner/themes/gardner-theme-b2c/views/account-profile.view.tsx'),
            cn: '__local__-__local__-account-profile'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|b2b-requests-status'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-b2b-requests-status' */
                'partner/themes/gardner-theme-b2c/views/b2b-requests-status.view.tsx'),
            cn: '__local__-__local__-b2b-requests-status'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|business-organization-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-business-organization-list' */
                'partner/themes/gardner-theme-b2c/views/business-organization-list.view.tsx'),
            cn: '__local__-__local__-business-organization-list'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|buybox'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-buybox' */
                'partner/themes/gardner-theme-b2c/views/buybox.view.tsx'),
            cn: '__local__-__local__-buybox'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|cart-icon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cart-icon' */
                'partner/themes/gardner-theme-b2c/views/cart-icon.view.tsx'),
            cn: '__local__-__local__-cart-icon'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|cart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cart' */
                'partner/themes/gardner-theme-b2c/views/cart.view.tsx'),
            cn: '__local__-__local__-cart'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|checkout-delivery-options'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-delivery-options' */
                'partner/themes/gardner-theme-b2c/views/checkout-delivery-options.view.tsx'),
            cn: '__local__-__local__-checkout-delivery-options'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|checkout-order-confirmation'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-order-confirmation' */
                'partner/themes/gardner-theme-b2c/views/checkout-order-confirmation.view.tsx'),
            cn: '__local__-__local__-checkout-order-confirmation'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|checkout-shipping-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-shipping-address' */
                'partner/themes/gardner-theme-b2c/views/checkout-shipping-address.view.tsx'),
            cn: '__local__-__local__-checkout-shipping-address'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|checkout'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout' */
                'partner/themes/gardner-theme-b2c/views/checkout.view.tsx'),
            cn: '__local__-__local__-checkout'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|content-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-content-block' */
                'partner/themes/gardner-theme-b2c/views/content-block.view.tsx'),
            cn: '__local__-__local__-content-block'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|cookie-compliance'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cookie-compliance' */
                'partner/themes/gardner-theme-b2c/views/cookie-compliance.view.tsx'),
            cn: '__local__-__local__-cookie-compliance'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|footer-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-footer-item' */
                'partner/themes/gardner-theme-b2c/views/footer-item.view.tsx'),
            cn: '__local__-__local__-footer-item'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|header'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-header' */
                'partner/themes/gardner-theme-b2c/views/header.view.tsx'),
            cn: '__local__-__local__-header'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|invoices-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-invoices-list' */
                'partner/themes/gardner-theme-b2c/views/invoices-list.view.tsx'),
            cn: '__local__-__local__-invoices-list'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|media-gallery'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-media-gallery' */
                'partner/themes/gardner-theme-b2c/views/media-gallery.view.tsx'),
            cn: '__local__-__local__-media-gallery'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|navigation-menu'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-navigation-menu' */
                'partner/themes/gardner-theme-b2c/views/navigation-menu.view.tsx'),
            cn: '__local__-__local__-navigation-menu'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|order-confirmation'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-confirmation' */
                'partner/themes/gardner-theme-b2c/views/order-confirmation.view.tsx'),
            cn: '__local__-__local__-order-confirmation'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|order-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-details' */
                'partner/themes/gardner-theme-b2c/views/order-details.view.tsx'),
            cn: '__local__-__local__-order-details'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|order-history'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-history' */
                'partner/themes/gardner-theme-b2c/views/order-history.view.tsx'),
            cn: '__local__-__local__-order-history'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|order-template-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-template-list' */
                'partner/themes/gardner-theme-b2c/views/order-template-list.view.tsx'),
            cn: '__local__-__local__-order-template-list'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|order-template'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-template' */
                'partner/themes/gardner-theme-b2c/views/order-template.view.tsx'),
            cn: '__local__-__local__-order-template'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|quickview'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-quickview' */
                'partner/themes/gardner-theme-b2c/views/quickview.view.tsx'),
            cn: '__local__-__local__-quickview'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|ratings-histogram'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-ratings-histogram' */
                'partner/themes/gardner-theme-b2c/views/ratings-histogram.view.tsx'),
            cn: '__local__-__local__-ratings-histogram'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|reviews-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-reviews-list' */
                'partner/themes/gardner-theme-b2c/views/reviews-list.view.tsx'),
            cn: '__local__-__local__-reviews-list'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|search-result-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-search-result-container' */
                'partner/themes/gardner-theme-b2c/views/search-result-container.view.tsx'),
            cn: '__local__-__local__-search-result-container'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|search'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-search' */
                'partner/themes/gardner-theme-b2c/views/search.view.tsx'),
            cn: '__local__-__local__-search'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|sign-in'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-sign-in' */
                'partner/themes/gardner-theme-b2c/views/sign-in.view.tsx'),
            cn: '__local__-__local__-sign-in'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-sign-up' */
                'partner/themes/gardner-theme-b2c/views/sign-up.view.tsx'),
            cn: '__local__-__local__-sign-up'
            };
viewDictionary['__local__|__local__|themes|gardner-theme-b2c|views|write-review'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-write-review' */
                'partner/themes/gardner-theme-b2c/views/write-review.view.tsx'),
            cn: '__local__-__local__-write-review'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|account-profile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-profile' */
                'partner/themes/gardner-theme/views/account-profile.view.tsx'),
            cn: '__local__-__local__-account-profile'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|account-welcome-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-welcome-tile' */
                'partner/themes/gardner-theme/views/account-welcome-tile.view.tsx'),
            cn: '__local__-__local__-account-welcome-tile'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|b2b-requests-status'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-b2b-requests-status' */
                'partner/themes/gardner-theme/views/b2b-requests-status.view.tsx'),
            cn: '__local__-__local__-b2b-requests-status'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|business-organization-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-business-organization-list' */
                'partner/themes/gardner-theme/views/business-organization-list.view.tsx'),
            cn: '__local__-__local__-business-organization-list'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|buybox'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-buybox' */
                'partner/themes/gardner-theme/views/buybox.view.tsx'),
            cn: '__local__-__local__-buybox'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|cart-icon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cart-icon' */
                'partner/themes/gardner-theme/views/cart-icon.view.tsx'),
            cn: '__local__-__local__-cart-icon'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|cart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cart' */
                'partner/themes/gardner-theme/views/cart.view.tsx'),
            cn: '__local__-__local__-cart'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|checkout-customer-account-payment'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-customer-account-payment' */
                'partner/themes/gardner-theme/views/checkout-customer-account-payment.view.tsx'),
            cn: '__local__-__local__-checkout-customer-account-payment'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|checkout-delivery-options'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-delivery-options' */
                'partner/themes/gardner-theme/views/checkout-delivery-options.view.tsx'),
            cn: '__local__-__local__-checkout-delivery-options'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|checkout-order-confirmation'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-order-confirmation' */
                'partner/themes/gardner-theme/views/checkout-order-confirmation.view.tsx'),
            cn: '__local__-__local__-checkout-order-confirmation'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|checkout-payment-instrument'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-payment-instrument' */
                'partner/themes/gardner-theme/views/checkout-payment-instrument.view.tsx'),
            cn: '__local__-__local__-checkout-payment-instrument'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|checkout-section-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-section-container' */
                'partner/themes/gardner-theme/views/checkout-section-container.view.tsx'),
            cn: '__local__-__local__-checkout-section-container'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|checkout-shipping-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-shipping-address' */
                'partner/themes/gardner-theme/views/checkout-shipping-address.view.tsx'),
            cn: '__local__-__local__-checkout-shipping-address'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|checkout'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout' */
                'partner/themes/gardner-theme/views/checkout.view.tsx'),
            cn: '__local__-__local__-checkout'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|content-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-content-block' */
                'partner/themes/gardner-theme/views/content-block.view.tsx'),
            cn: '__local__-__local__-content-block'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|cookie-compliance'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cookie-compliance' */
                'partner/themes/gardner-theme/views/cookie-compliance.view.tsx'),
            cn: '__local__-__local__-cookie-compliance'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|footer-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-footer-item' */
                'partner/themes/gardner-theme/views/footer-item.view.tsx'),
            cn: '__local__-__local__-footer-item'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|header'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-header' */
                'partner/themes/gardner-theme/views/header.view.tsx'),
            cn: '__local__-__local__-header'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|invoice-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-invoice-details' */
                'partner/themes/gardner-theme/views/invoice-details.view.tsx'),
            cn: '__local__-__local__-invoice-details'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|invoices-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-invoices-list' */
                'partner/themes/gardner-theme/views/invoices-list.view.tsx'),
            cn: '__local__-__local__-invoices-list'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|media-gallery'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-media-gallery' */
                'partner/themes/gardner-theme/views/media-gallery.view.tsx'),
            cn: '__local__-__local__-media-gallery'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|navigation-menu'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-navigation-menu' */
                'partner/themes/gardner-theme/views/navigation-menu.view.tsx'),
            cn: '__local__-__local__-navigation-menu'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|order-confirmation'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-confirmation' */
                'partner/themes/gardner-theme/views/order-confirmation.view.tsx'),
            cn: '__local__-__local__-order-confirmation'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|order-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-details' */
                'partner/themes/gardner-theme/views/order-details.view.tsx'),
            cn: '__local__-__local__-order-details'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|order-history'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-history' */
                'partner/themes/gardner-theme/views/order-history.view.tsx'),
            cn: '__local__-__local__-order-history'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|order-template-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-template-list' */
                'partner/themes/gardner-theme/views/order-template-list.view.tsx'),
            cn: '__local__-__local__-order-template-list'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|order-template'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-template' */
                'partner/themes/gardner-theme/views/order-template.view.tsx'),
            cn: '__local__-__local__-order-template'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|quickview'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-quickview' */
                'partner/themes/gardner-theme/views/quickview.view.tsx'),
            cn: '__local__-__local__-quickview'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|ratings-histogram'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-ratings-histogram' */
                'partner/themes/gardner-theme/views/ratings-histogram.view.tsx'),
            cn: '__local__-__local__-ratings-histogram'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|reviews-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-reviews-list' */
                'partner/themes/gardner-theme/views/reviews-list.view.tsx'),
            cn: '__local__-__local__-reviews-list'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|search-result-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-search-result-container' */
                'partner/themes/gardner-theme/views/search-result-container.view.tsx'),
            cn: '__local__-__local__-search-result-container'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|search'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-search' */
                'partner/themes/gardner-theme/views/search.view.tsx'),
            cn: '__local__-__local__-search'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|sign-in'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-sign-in' */
                'partner/themes/gardner-theme/views/sign-in.view.tsx'),
            cn: '__local__-__local__-sign-in'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-sign-up' */
                'partner/themes/gardner-theme/views/sign-up.view.tsx'),
            cn: '__local__-__local__-sign-up'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|text-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-text-block' */
                'partner/themes/gardner-theme/views/text-block.view.tsx'),
            cn: '__local__-__local__-text-block'
            };
viewDictionary['__local__|__local__|themes|gardner-theme|views|write-review'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-write-review' */
                'partner/themes/gardner-theme/views/write-review.view.tsx'),
            cn: '__local__-__local__-write-review'
            };
viewDictionary['@msdyn365-commerce-modules|accordion|modules|accordion-item|accordion-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-accordion-accordion-item' */
                '@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion-item/accordion-item.view.js'),
            cn: '@msdyn365-commerce-modules-accordion-accordion-item'
            };
viewDictionary['@msdyn365-commerce-modules|accordion|modules|accordion|accordion'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-accordion-accordion' */
                '@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion/accordion.view.js'),
            cn: '@msdyn365-commerce-modules-accordion-accordion'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|aad-generic|aad-generic'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-aad-generic' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/aad-generic/aad-generic.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-aad-generic'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-address-tile|account-address-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-address-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-address-tile/account-address-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-address-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-customer-balance-tile|account-customer-balance-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-customer-balance-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance-tile/account-customer-balance-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-customer-balance-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-customer-balance|account-customer-balance'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-customer-balance' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance/account-customer-balance.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-customer-balance'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-generic-tile|account-generic-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-generic-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-generic-tile/account-generic-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-generic-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-invoice-tile|account-invoice-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-invoice-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-invoice-tile/account-invoice-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-invoice-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-loyalty-tile|account-loyalty-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-loyalty-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty-tile/account-loyalty-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-loyalty-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-loyalty|account-loyalty'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-loyalty' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty/account-loyalty.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-loyalty'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-order-templates-tile|account-order-templates-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-order-templates-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-order-templates-tile/account-order-templates-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-order-templates-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-profile-edit|account-profile-edit'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-profile-edit' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile-edit/account-profile-edit.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-profile-edit'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-profile|account-profile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-profile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile/account-profile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-profile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-welcome-tile|account-welcome-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-welcome-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-welcome-tile/account-welcome-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-welcome-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-wishlist-tile|account-wishlist-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-wishlist-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-wishlist-tile/account-wishlist-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-wishlist-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|b2b-requests-status|b2b-requests-status'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-b2b-requests-status' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-status/b2b-requests-status.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-b2b-requests-status'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|b2b-requests-tile|b2b-requests-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-b2b-requests-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-tile/b2b-requests-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-b2b-requests-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|loyalty-sign-up|loyalty-sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-loyalty-sign-up' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-sign-up/loyalty-sign-up.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-loyalty-sign-up'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|loyalty-terms|loyalty-terms'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-loyalty-terms' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-terms/loyalty-terms.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-loyalty-terms'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|organization-users-tile|organization-users-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-organization-users-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/organization-users-tile/organization-users-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-organization-users-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|password-reset-verification|password-reset-verification'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-password-reset-verification' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset-verification/password-reset-verification.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-password-reset-verification'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|password-reset|password-reset'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-password-reset' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset/password-reset.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-password-reset'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|sign-in|sign-in'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-sign-in' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-in/sign-in.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-sign-in'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|sign-up|sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-sign-up' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-up/sign-up.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-sign-up'
            };
viewDictionary['@msdyn365-commerce-modules|active-image|modules|active-image|active-image'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-active-image-active-image' */
                '@msdyn365-commerce-modules/active-image/dist/lib/modules/active-image/active-image.view.js'),
            cn: '@msdyn365-commerce-modules-active-image-active-image'
            };
viewDictionary['@msdyn365-commerce-modules|address|modules|account-management-address|account-management-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-address-account-management-address' */
                '@msdyn365-commerce-modules/address/dist/lib/modules/account-management-address/account-management-address.view.js'),
            cn: '@msdyn365-commerce-modules-address-account-management-address'
            };
viewDictionary['@msdyn365-commerce-modules|address|modules|business-account-address|business-account-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-address-business-account-address' */
                '@msdyn365-commerce-modules/address/dist/lib/modules/business-account-address/business-account-address.view.js'),
            cn: '@msdyn365-commerce-modules-address-business-account-address'
            };
viewDictionary['@msdyn365-commerce-modules|address|modules|checkout-billing-address|checkout-billing-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-address-checkout-billing-address' */
                '@msdyn365-commerce-modules/address/dist/lib/modules/checkout-billing-address/checkout-billing-address.view.js'),
            cn: '@msdyn365-commerce-modules-address-checkout-billing-address'
            };
viewDictionary['@msdyn365-commerce-modules|address|modules|checkout-shipping-address|checkout-shipping-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-address-checkout-shipping-address' */
                '@msdyn365-commerce-modules/address/dist/lib/modules/checkout-shipping-address/checkout-shipping-address.view.js'),
            cn: '@msdyn365-commerce-modules-address-checkout-shipping-address'
            };
viewDictionary['@msdyn365-commerce-modules|azure-maps|modules|azure-maps|azure-maps'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-azure-maps-azure-maps' */
                '@msdyn365-commerce-modules/azure-maps/dist/lib/modules/azure-maps/azure-maps.view.js'),
            cn: '@msdyn365-commerce-modules-azure-maps-azure-maps'
            };
viewDictionary['@msdyn365-commerce-modules|breadcrumb|modules|breadcrumb|breadcrumb'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-breadcrumb-breadcrumb' */
                '@msdyn365-commerce-modules/breadcrumb/dist/lib/modules/breadcrumb/breadcrumb.view.js'),
            cn: '@msdyn365-commerce-modules-breadcrumb-breadcrumb'
            };
viewDictionary['@msdyn365-commerce-modules|bulk-purchase|modules|bulk-purchase|bulk-purchase'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-bulk-purchase-bulk-purchase' */
                '@msdyn365-commerce-modules/bulk-purchase/dist/lib/modules/bulk-purchase/bulk-purchase.view.js'),
            cn: '@msdyn365-commerce-modules-bulk-purchase-bulk-purchase'
            };
viewDictionary['@msdyn365-commerce-modules|business-account-management|modules|business-sign-up|business-sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-business-account-management-business-sign-up' */
                '@msdyn365-commerce-modules/business-account-management/dist/lib/modules/business-sign-up/business-sign-up.view.js'),
            cn: '@msdyn365-commerce-modules-business-account-management-business-sign-up'
            };
viewDictionary['@msdyn365-commerce-modules|business-organization-list|modules|business-organization-list|business-organization-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-business-organization-list-business-organization-list' */
                '@msdyn365-commerce-modules/business-organization-list/dist/lib/modules/business-organization-list/business-organization-list.view.js'),
            cn: '@msdyn365-commerce-modules-business-organization-list-business-organization-list'
            };
viewDictionary['@msdyn365-commerce-modules|business-partner-promotion|modules|business-partner-promotion|business-partner-promotion'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-business-partner-promotion-business-partner-promotion' */
                '@msdyn365-commerce-modules/business-partner-promotion/dist/lib/modules/business-partner-promotion/business-partner-promotion.view.js'),
            cn: '@msdyn365-commerce-modules-business-partner-promotion-business-partner-promotion'
            };
viewDictionary['@msdyn365-commerce-modules|business-partners|modules|business-partners|business-partners'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-business-partners-business-partners' */
                '@msdyn365-commerce-modules/business-partners/dist/lib/modules/business-partners/business-partners.view.js'),
            cn: '@msdyn365-commerce-modules-business-partners-business-partners'
            };
viewDictionary['@msdyn365-commerce-modules|buybox|modules|buybox|buybox'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-buybox-buybox' */
                '@msdyn365-commerce-modules/buybox/dist/lib/modules/buybox/buybox.view.js'),
            cn: '@msdyn365-commerce-modules-buybox-buybox'
            };
viewDictionary['@msdyn365-commerce-modules|buybox|modules|quickview|quickview'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-buybox-quickview' */
                '@msdyn365-commerce-modules/buybox/dist/lib/modules/quickview/quickview.view.js'),
            cn: '@msdyn365-commerce-modules-buybox-quickview'
            };
viewDictionary['@msdyn365-commerce-modules|carousel|modules|carousel|carousel'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-carousel-carousel' */
                '@msdyn365-commerce-modules/carousel/dist/lib/modules/carousel/carousel.view.js'),
            cn: '@msdyn365-commerce-modules-carousel-carousel'
            };
viewDictionary['@msdyn365-commerce-modules|cart|modules|cart-icon|cart-icon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-cart-cart-icon' */
                '@msdyn365-commerce-modules/cart/dist/lib/modules/cart-icon/cart-icon.view.js'),
            cn: '@msdyn365-commerce-modules-cart-cart-icon'
            };
viewDictionary['@msdyn365-commerce-modules|cart|modules|cart|cart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-cart-cart' */
                '@msdyn365-commerce-modules/cart/dist/lib/modules/cart/cart.view.js'),
            cn: '@msdyn365-commerce-modules-cart-cart'
            };
viewDictionary['@msdyn365-commerce-modules|catalog-picker|modules|catalog-picker|catalog-picker'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-catalog-picker-catalog-picker' */
                '@msdyn365-commerce-modules/catalog-picker/dist/lib/modules/catalog-picker/catalog-picker.view.js'),
            cn: '@msdyn365-commerce-modules-catalog-picker-catalog-picker'
            };
viewDictionary['@msdyn365-commerce-modules|chat|modules|msdyn365-cs-chat-connector|msdyn365-cs-chat-connector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-chat-msdyn365-cs-chat-connector' */
                '@msdyn365-commerce-modules/chat/dist/lib/modules/msdyn365-cs-chat-connector/msdyn365-cs-chat-connector.view.js'),
            cn: '@msdyn365-commerce-modules-chat-msdyn365-cs-chat-connector'
            };
viewDictionary['@msdyn365-commerce-modules|chat|modules|msdyn365-pva-chat-connector|msdyn365-pva-chat-connector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-chat-msdyn365-pva-chat-connector' */
                '@msdyn365-commerce-modules/chat/dist/lib/modules/msdyn365-pva-chat-connector/msdyn365-pva-chat-connector.view.js'),
            cn: '@msdyn365-commerce-modules-chat-msdyn365-pva-chat-connector'
            };
viewDictionary['@msdyn365-commerce-modules|check-in-for-pickup|modules|check-in-for-pickup|check-in-for-pickup'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-check-in-for-pickup-check-in-for-pickup' */
                '@msdyn365-commerce-modules/check-in-for-pickup/dist/lib/modules/check-in-for-pickup/check-in-for-pickup.view.js'),
            cn: '@msdyn365-commerce-modules-check-in-for-pickup-check-in-for-pickup'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-apple-pay|checkout-apple-pay'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-apple-pay' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-apple-pay/checkout-apple-pay.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-apple-pay'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-customer-account-payment|checkout-customer-account-payment'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-customer-account-payment' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-customer-account-payment/checkout-customer-account-payment.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-customer-account-payment'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-delivery-options|checkout-delivery-options'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-delivery-options' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-delivery-options/checkout-delivery-options.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-delivery-options'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-express-payment-container|checkout-express-payment-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-express-payment-container' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-express-payment-container/checkout-express-payment-container.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-express-payment-container'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-express|checkout-express'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-express' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-express/checkout-express.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-express'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-gift-card|checkout-gift-card'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-gift-card' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-gift-card/checkout-gift-card.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-gift-card'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-google-pay|checkout-google-pay'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-google-pay' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-google-pay/checkout-google-pay.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-google-pay'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-guest-profile|checkout-guest-profile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-guest-profile' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-guest-profile/checkout-guest-profile.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-guest-profile'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-loyalty|checkout-loyalty'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-loyalty' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-loyalty/checkout-loyalty.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-loyalty'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-payment-instrument|checkout-payment-instrument'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-payment-instrument' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument/checkout-payment-instrument.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-payment-instrument'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-pickup|checkout-pickup'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-pickup' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-pickup/checkout-pickup.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-pickup'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-section-container|checkout-section-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-section-container' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-section-container/checkout-section-container.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-section-container'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-terms-and-conditions|checkout-terms-and-conditions'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-terms-and-conditions' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-terms-and-conditions/checkout-terms-and-conditions.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-terms-and-conditions'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout|checkout'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/checkout.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|gift-card-balance-check|gift-card-balance-check'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-gift-card-balance-check' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/gift-card-balance-check/gift-card-balance-check.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-gift-card-balance-check'
            };
viewDictionary['@msdyn365-commerce-modules|content-block|modules|content-block|content-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-content-block-content-block' */
                '@msdyn365-commerce-modules/content-block/dist/lib/modules/content-block/content-block.view.js'),
            cn: '@msdyn365-commerce-modules-content-block-content-block'
            };
viewDictionary['@msdyn365-commerce-modules|cookie-compliance|modules|cookie-compliance|cookie-compliance'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-cookie-compliance-cookie-compliance' */
                '@msdyn365-commerce-modules/cookie-compliance/dist/lib/modules/cookie-compliance/cookie-compliance.view.js'),
            cn: '@msdyn365-commerce-modules-cookie-compliance-cookie-compliance'
            };
viewDictionary['@msdyn365-commerce-modules|country-picker|modules|country-picker|country-picker'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-country-picker-country-picker' */
                '@msdyn365-commerce-modules/country-picker/dist/lib/modules/country-picker/country-picker.view.js'),
            cn: '@msdyn365-commerce-modules-country-picker-country-picker'
            };
viewDictionary['@msdyn365-commerce-modules|distributor-selector|modules|distributor-selector|distributor-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-distributor-selector-distributor-selector' */
                '@msdyn365-commerce-modules/distributor-selector/dist/lib/modules/distributor-selector/distributor-selector.view.js'),
            cn: '@msdyn365-commerce-modules-distributor-selector-distributor-selector'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|buybox'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-buybox' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/buybox.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-buybox'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|cart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-cart' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/cart.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-cart'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|header'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-header' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/header.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-header'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|navigation-menu'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-navigation-menu' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/navigation-menu.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-navigation-menu'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|order-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-order-details' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/order-details.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-order-details'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|order-history'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-order-history' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/order-history.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-order-history'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|ratings-histogram'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-ratings-histogram' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/ratings-histogram.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-ratings-histogram'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|reviews-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-reviews-list' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/reviews-list.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-reviews-list'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|search-result-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-search-result-container' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/search-result-container.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-search-result-container'
            };
viewDictionary['@msdyn365-commerce-modules|footer|modules|footer-category|footer-category'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-footer-footer-category' */
                '@msdyn365-commerce-modules/footer/dist/lib/modules/footer-category/footer-category.view.js'),
            cn: '@msdyn365-commerce-modules-footer-footer-category'
            };
viewDictionary['@msdyn365-commerce-modules|footer|modules|footer-item|footer-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-footer-footer-item' */
                '@msdyn365-commerce-modules/footer/dist/lib/modules/footer-item/footer-item.view.js'),
            cn: '@msdyn365-commerce-modules-footer-footer-item'
            };
viewDictionary['@msdyn365-commerce-modules|header|modules|header|header'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-header-header' */
                '@msdyn365-commerce-modules/header/dist/lib/modules/header/header.view.js'),
            cn: '@msdyn365-commerce-modules-header-header'
            };
viewDictionary['@msdyn365-commerce-modules|html-block|modules|html-block|html-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-html-block-html-block' */
                '@msdyn365-commerce-modules/html-block/dist/lib/modules/html-block/html-block.view.js'),
            cn: '@msdyn365-commerce-modules-html-block-html-block'
            };
viewDictionary['@msdyn365-commerce-modules|iframe|modules|iframe|iframe'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-iframe-iframe' */
                '@msdyn365-commerce-modules/iframe/dist/lib/modules/iframe/iframe.view.js'),
            cn: '@msdyn365-commerce-modules-iframe-iframe'
            };
viewDictionary['@msdyn365-commerce-modules|image-list|modules|image-list|image-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-image-list-image-list' */
                '@msdyn365-commerce-modules/image-list/dist/lib/modules/image-list/image-list.view.js'),
            cn: '@msdyn365-commerce-modules-image-list-image-list'
            };
viewDictionary['@msdyn365-commerce-modules|interactive-feature-collection|modules|interactive-feature-collection|interactive-feature-collection'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-interactive-feature-collection-interactive-feature-collection' */
                '@msdyn365-commerce-modules/interactive-feature-collection/dist/lib/modules/interactive-feature-collection/interactive-feature-collection.view.js'),
            cn: '@msdyn365-commerce-modules-interactive-feature-collection-interactive-feature-collection'
            };
viewDictionary['@msdyn365-commerce-modules|interactive-feature-collection|modules|interactive-feature-item|interactive-feature-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-interactive-feature-collection-interactive-feature-item' */
                '@msdyn365-commerce-modules/interactive-feature-collection/dist/lib/modules/interactive-feature-item/interactive-feature-item.view.js'),
            cn: '@msdyn365-commerce-modules-interactive-feature-collection-interactive-feature-item'
            };
viewDictionary['@msdyn365-commerce-modules|invoice-details|modules|invoice-details|invoice-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-invoice-details-invoice-details' */
                '@msdyn365-commerce-modules/invoice-details/dist/lib/modules/invoice-details/invoice-details.view.js'),
            cn: '@msdyn365-commerce-modules-invoice-details-invoice-details'
            };
viewDictionary['@msdyn365-commerce-modules|invoice|modules|invoices-list|invoices-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-invoice-invoices-list' */
                '@msdyn365-commerce-modules/invoice/dist/lib/modules/invoices-list/invoices-list.view.js'),
            cn: '@msdyn365-commerce-modules-invoice-invoices-list'
            };
viewDictionary['@msdyn365-commerce-modules|map|modules|map|map'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-map-map' */
                '@msdyn365-commerce-modules/map/dist/lib/modules/map/map.view.js'),
            cn: '@msdyn365-commerce-modules-map-map'
            };
viewDictionary['@msdyn365-commerce-modules|media-gallery|modules|media-gallery|media-gallery'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-media-gallery-media-gallery' */
                '@msdyn365-commerce-modules/media-gallery/dist/lib/modules/media-gallery/media-gallery.view.js'),
            cn: '@msdyn365-commerce-modules-media-gallery-media-gallery'
            };
viewDictionary['@msdyn365-commerce-modules|navigation-menu|modules|navigation-menu|navigation-menu'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-navigation-menu-navigation-menu' */
                '@msdyn365-commerce-modules/navigation-menu/dist/lib/modules/navigation-menu/navigation-menu.view.js'),
            cn: '@msdyn365-commerce-modules-navigation-menu-navigation-menu'
            };
viewDictionary['@msdyn365-commerce-modules|notifications-lists|modules|notifications-list|notifications-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-notifications-lists-notifications-list' */
                '@msdyn365-commerce-modules/notifications-lists/dist/lib/modules/notifications-list/notifications-list.view.js'),
            cn: '@msdyn365-commerce-modules-notifications-lists-notifications-list'
            };
viewDictionary['@msdyn365-commerce-modules|order-management|modules|checkout-order-confirmation|checkout-order-confirmation'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-checkout-order-confirmation' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/checkout-order-confirmation/checkout-order-confirmation.view.js'),
            cn: '@msdyn365-commerce-modules-order-management-checkout-order-confirmation'
            };
viewDictionary['@msdyn365-commerce-modules|order-management|modules|order-confirmation|order-confirmation'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-confirmation' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-confirmation/order-confirmation.view.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-confirmation'
            };
viewDictionary['@msdyn365-commerce-modules|order-management|modules|order-details|order-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-details' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-details/order-details.view.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-details'
            };
viewDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|order-history-with-search-and-filters'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/order-history-with-search-and-filters.view.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters'
            };
viewDictionary['@msdyn365-commerce-modules|order-management|modules|order-history|order-history'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history/order-history.view.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history'
            };
viewDictionary['@msdyn365-commerce-modules|order-management|modules|order-lookup|order-lookup'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-lookup' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-lookup/order-lookup.view.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-lookup'
            };
viewDictionary['@msdyn365-commerce-modules|order-template|modules|order-template-list|order-template-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-template-order-template-list' */
                '@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template-list/order-template-list.view.js'),
            cn: '@msdyn365-commerce-modules-order-template-order-template-list'
            };
viewDictionary['@msdyn365-commerce-modules|order-template|modules|order-template|order-template'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-template-order-template' */
                '@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template/order-template.view.js'),
            cn: '@msdyn365-commerce-modules-order-template-order-template'
            };
viewDictionary['@msdyn365-commerce-modules|product-collection|modules|product-collection|product-collection'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-product-collection-product-collection' */
                '@msdyn365-commerce-modules/product-collection/dist/lib/modules/product-collection/product-collection.view.js'),
            cn: '@msdyn365-commerce-modules-product-collection-product-collection'
            };
viewDictionary['@msdyn365-commerce-modules|product-comparison|modules|product-comparison-button|product-comparison-button'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-product-comparison-product-comparison-button' */
                '@msdyn365-commerce-modules/product-comparison/dist/lib/modules/product-comparison-button/product-comparison-button.view.js'),
            cn: '@msdyn365-commerce-modules-product-comparison-product-comparison-button'
            };
viewDictionary['@msdyn365-commerce-modules|product-comparison|modules|product-comparison-preview|product-comparison-preview'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-product-comparison-product-comparison-preview' */
                '@msdyn365-commerce-modules/product-comparison/dist/lib/modules/product-comparison-preview/product-comparison-preview.view.js'),
            cn: '@msdyn365-commerce-modules-product-comparison-product-comparison-preview'
            };
viewDictionary['@msdyn365-commerce-modules|product-comparison|modules|product-comparison|product-comparison'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-product-comparison-product-comparison' */
                '@msdyn365-commerce-modules/product-comparison/dist/lib/modules/product-comparison/product-comparison.view.js'),
            cn: '@msdyn365-commerce-modules-product-comparison-product-comparison'
            };
viewDictionary['@msdyn365-commerce-modules|product-specification|modules|product-specification|product-specification'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-product-specification-product-specification' */
                '@msdyn365-commerce-modules/product-specification/dist/lib/modules/product-specification/product-specification.view.js'),
            cn: '@msdyn365-commerce-modules-product-specification-product-specification'
            };
viewDictionary['@msdyn365-commerce-modules|promo-banner|modules|promo-banner|promo-banner'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-promo-banner-promo-banner' */
                '@msdyn365-commerce-modules/promo-banner/dist/lib/modules/promo-banner/promo-banner.view.js'),
            cn: '@msdyn365-commerce-modules-promo-banner-promo-banner'
            };
viewDictionary['@msdyn365-commerce-modules|quick-order-grid|modules|quick-order-grid|quick-order-grid'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-quick-order-grid-quick-order-grid' */
                '@msdyn365-commerce-modules/quick-order-grid/dist/lib/modules/quick-order-grid/quick-order-grid.view.js'),
            cn: '@msdyn365-commerce-modules-quick-order-grid-quick-order-grid'
            };
viewDictionary['@msdyn365-commerce-modules|quick-order|modules|quick-order|quick-order'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-quick-order-quick-order' */
                '@msdyn365-commerce-modules/quick-order/dist/lib/modules/quick-order/quick-order.view.js'),
            cn: '@msdyn365-commerce-modules-quick-order-quick-order'
            };
viewDictionary['@msdyn365-commerce-modules|ratings-reviews|modules|ratings-histogram|ratings-histogram'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-ratings-reviews-ratings-histogram' */
                '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/ratings-histogram/ratings-histogram.view.js'),
            cn: '@msdyn365-commerce-modules-ratings-reviews-ratings-histogram'
            };
viewDictionary['@msdyn365-commerce-modules|ratings-reviews|modules|reviews-list|reviews-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-ratings-reviews-reviews-list' */
                '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/reviews-list/reviews-list.view.js'),
            cn: '@msdyn365-commerce-modules-ratings-reviews-reviews-list'
            };
viewDictionary['@msdyn365-commerce-modules|ratings-reviews|modules|write-review|write-review'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-ratings-reviews-write-review' */
                '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/write-review/write-review.view.js'),
            cn: '@msdyn365-commerce-modules-ratings-reviews-write-review'
            };
viewDictionary['@msdyn365-commerce-modules|search-result-container|modules|search-result-container|search-result-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-search-result-container-search-result-container' */
                '@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/search-result-container.view.js'),
            cn: '@msdyn365-commerce-modules-search-result-container-search-result-container'
            };
viewDictionary['@msdyn365-commerce-modules|search|modules|search|search'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-search-search' */
                '@msdyn365-commerce-modules/search/dist/lib/modules/search/search.view.js'),
            cn: '@msdyn365-commerce-modules-search-search'
            };
viewDictionary['@msdyn365-commerce-modules|site-picker|modules|site-picker|site-picker'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-site-picker-site-picker' */
                '@msdyn365-commerce-modules/site-picker/dist/lib/modules/site-picker/site-picker.view.js'),
            cn: '@msdyn365-commerce-modules-site-picker-site-picker'
            };
viewDictionary['@msdyn365-commerce-modules|social-share|modules|social-share-item|social-share-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-social-share-social-share-item' */
                '@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share-item/social-share-item.view.js'),
            cn: '@msdyn365-commerce-modules-social-share-social-share-item'
            };
viewDictionary['@msdyn365-commerce-modules|social-share|modules|social-share|social-share'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-social-share-social-share' */
                '@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share/social-share.view.js'),
            cn: '@msdyn365-commerce-modules-social-share-social-share'
            };
viewDictionary['@msdyn365-commerce-modules|spacer|modules|spacer|spacer'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-spacer-spacer' */
                '@msdyn365-commerce-modules/spacer/dist/lib/modules/spacer/spacer.view.js'),
            cn: '@msdyn365-commerce-modules-spacer-spacer'
            };
viewDictionary['@msdyn365-commerce-modules|store-selector|modules|store-selector|store-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-store-selector-store-selector' */
                '@msdyn365-commerce-modules/store-selector/dist/lib/modules/store-selector/store-selector.view.js'),
            cn: '@msdyn365-commerce-modules-store-selector-store-selector'
            };
viewDictionary['@msdyn365-commerce-modules|subscribe|modules|subscribe|subscribe'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-subscribe-subscribe' */
                '@msdyn365-commerce-modules/subscribe/dist/lib/modules/subscribe/subscribe.view.js'),
            cn: '@msdyn365-commerce-modules-subscribe-subscribe'
            };
viewDictionary['@msdyn365-commerce-modules|tab|modules|tab-item|tab-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-tab-tab-item' */
                '@msdyn365-commerce-modules/tab/dist/lib/modules/tab-item/tab-item.view.js'),
            cn: '@msdyn365-commerce-modules-tab-tab-item'
            };
viewDictionary['@msdyn365-commerce-modules|tab|modules|tab|tab'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-tab-tab' */
                '@msdyn365-commerce-modules/tab/dist/lib/modules/tab/tab.view.js'),
            cn: '@msdyn365-commerce-modules-tab-tab'
            };
viewDictionary['@msdyn365-commerce-modules|text-block|modules|text-block|text-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-text-block-text-block' */
                '@msdyn365-commerce-modules/text-block/dist/lib/modules/text-block/text-block.view.js'),
            cn: '@msdyn365-commerce-modules-text-block-text-block'
            };
viewDictionary['@msdyn365-commerce-modules|tile-list|modules|tile-list-item|tile-list-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-tile-list-tile-list-item' */
                '@msdyn365-commerce-modules/tile-list/dist/lib/modules/tile-list-item/tile-list-item.view.js'),
            cn: '@msdyn365-commerce-modules-tile-list-tile-list-item'
            };
viewDictionary['@msdyn365-commerce-modules|tile-list|modules|tile-list|tile-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-tile-list-tile-list' */
                '@msdyn365-commerce-modules/tile-list/dist/lib/modules/tile-list/tile-list.view.js'),
            cn: '@msdyn365-commerce-modules-tile-list-tile-list'
            };
viewDictionary['@msdyn365-commerce-modules|video-player|modules|video-player|video-player'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-video-player-video-player' */
                '@msdyn365-commerce-modules/video-player/dist/lib/modules/video-player/video-player.view.js'),
            cn: '@msdyn365-commerce-modules-video-player-video-player'
            };
viewDictionary['@msdyn365-commerce-modules|wishlist|modules|wishlist-items|wishlist-items'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-wishlist-wishlist-items' */
                '@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/wishlist-items.view.js'),
            cn: '@msdyn365-commerce-modules-wishlist-wishlist-items'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|b2b-requests-status'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-b2b-requests-status' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/b2b-requests-status.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-b2b-requests-status'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|business-organization-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-business-organization-list' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/business-organization-list.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-business-organization-list'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|buybox'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-buybox' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/buybox.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-buybox'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|cart-icon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-cart-icon' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/cart-icon.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-cart-icon'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|cart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-cart' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/cart.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-cart'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|checkout-customer-account-payment'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-checkout-customer-account-payment' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/checkout-customer-account-payment.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-checkout-customer-account-payment'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|content-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-content-block' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/content-block.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-content-block'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|footer-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-footer-item' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/footer-item.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-footer-item'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|header'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-header' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/header.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-header'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|media-gallery'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-media-gallery' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/media-gallery.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-media-gallery'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|navigation-menu'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-navigation-menu' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/navigation-menu.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-navigation-menu'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|order-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-order-details' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/order-details.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-order-details'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|order-history'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-order-history' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/order-history.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-order-history'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|order-template-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-order-template-list' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/order-template-list.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-order-template-list'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|quickview'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-quickview' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/quickview.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-quickview'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|ratings-histogram'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-ratings-histogram' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/ratings-histogram.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-ratings-histogram'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|reviews-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-reviews-list' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/reviews-list.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-reviews-list'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|search-result-container-v2'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-search-result-container-v2' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/search-result-container-v2.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-search-result-container-v2'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|search-result-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-search-result-container' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/search-result-container.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-search-result-container'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|search'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-search' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/search.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-search'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|sign-in'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-sign-in' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/sign-in.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-sign-in'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|store-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-store-selector' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/store-selector.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-store-selector'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|write-review'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-write-review' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/write-review.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-write-review'
            };